module.exports = __webpack_public_path__ + "static/media/scrollRightIcon.dd55f5be.svg";